import React from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoLinkedin } from '@eventbrite/legacy-eds.iconography';
import { openUrl } from './utils';
import type { UtmOptions } from './types';

export const STATIC_LINKEDIN_URL = '/organizations/marketing/share-on-social/integrations/linkedin';

export const STATIC_SETTINGS = {
    name: '_blank',
    noPopup: true,
    width: 600,
    height: 400,
};

interface LinkedinShareProps {
    resourceId: string;
    resourceUrl: string;
    resourceType: string;
    onClick?: () => void;
    staticUrl?: boolean;
    utmOptions?: UtmOptions;
    dataHeapId?: string;
    shareMethod?: string;
    dataPageArea?: string;
    className?: string;
}

const _getResourceUrl = (resourceUrl: string, utmOptions?: UtmOptions) => {
    const url = new URL(resourceUrl);
    url.searchParams.set('aff', 'esli');
    if (utmOptions) {
        Object.entries(utmOptions).forEach(([key, value]) => {
            url.searchParams.set(key, value);
        });
    }
    return url.toString();
};

class LinkedinShareComponent extends React.Component<
    LinkedinShareProps & WrappedComponentProps<'intl'>
> {
    _handleButtonClick() {
        const { resourceUrl, onClick, staticUrl = false, utmOptions } = this.props;

        if (onClick) {
            onClick();
        }

        if (staticUrl) {
            openUrl(STATIC_LINKEDIN_URL, STATIC_SETTINGS);
        } else {
            const url = new URL('https://www.linkedin.com/shareArticle');
            url.searchParams.set('url', _getResourceUrl(resourceUrl, utmOptions));
            openUrl(url.toString());
        }
    }

    render() {
        const { intl } = this.props;
        return (
            <span
                className={this.props.className}
                data-testid="linkedin-share-box-container"
                data-heap-id={this.props.dataHeapId}
                data-share-method={this.props.shareMethod}
                data-page-area={this.props.dataPageArea}
                {...{
                    [`data-${this.props.resourceType}-id`]: this.props.resourceId,
                }}
            >
                <IconButton
                    onClick={this._handleButtonClick.bind(this)}
                    iconType={<LogoLinkedin />}
                    title={intl.formatMessage({
                        id: 'Share on Linkedin',
                        defaultMessage: 'Share on Linkedin',
                    })}
                />
            </span>
        );
    }
}

export const LinkedinShare = injectIntl(LinkedinShareComponent);
